import {Inject, Injectable} from '@angular/core';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {environment, CustomEnvironment, setApiOverrides} from '../../environments/environment';
import {catchError, tap} from 'rxjs/operators';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';
import {forkJoin, Observable} from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class TypesService {
  private handleError: HandleError;
  private loadedTypes = {};


  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService,
              @Inject(CustomEnvironment) customEnvironment: any) {
    setApiOverrides(customEnvironment);
    
    this.oauthService.events.subscribe((event: OAuthEvent) => {
      const tokenUpdatedEvents = ['token_refreshed', 'token_received', 'silently_refreshed'];
      if (tokenUpdatedEvents.includes(event.type)) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
      }
    });

    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('TypesService');

  }

  // get types list based on the name
  getTypesList(name: string): Promise<any> {
    if (!this.loadedTypes[name]) {
      this.loadedTypes[name] = this.http.get<any[]>(`${environment.api.types}/list/${name}`, httpOptions)
        .pipe(
          tap( // Log the result or error
            data => {
              sessionStorage.setItem(name, JSON.stringify(data));
            },
          ),
          catchError(this.handleError('getTypesList', []))
        )
        .toPromise()
      ;
    }
    return this.loadedTypes[name];
  }

  getTypes(types: Array<string>): Observable<any> {
    return forkJoin(types.map((type) => this.getTypesList(type)));
  }
}
